import React from "react";
import { IconFont } from "./style";
import "./icon-font-asesst/iconfont.js";
/**
 * 图标
 *
 * @author 张卓诚
 * @date 2019-01-03
 * @export
 * @class Icon
 * @extends {React.PureComponent<IconProps>}
 * @implements {IconInterface}
 */
export class Icon extends React.PureComponent {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(IconFont, null),
            React.createElement("svg", Object.assign({}, Object.assign({ "aria-hidden": true }, this.props, { className: `${this.props.className ? this.props.className : ""} gago-frame-jiage` })),
                React.createElement("use", { xlinkHref: `#icon-${this.props.children}` }))));
    }
}
//# sourceMappingURL=index.js.map